import $ from 'jquery';
import Cookies from 'js-cookie';
import localize from './localize';

// eslint-disable-next-line
import fancybox from '@fancyapps/fancybox';

function showContent(element) {
  const prompt = element.querySelector('.c-privacy-prompt');
  if (prompt) {
    element.removeChild(prompt);
  }

  delete element.dataset.hasPrivacyPrompt;

  if (element.dataset.iframeSrc) {
    let iframeAttributes = element.dataset.iframeAttributes;
    if (iframeAttributes === undefined) {
      iframeAttributes = '';
    }
    element.insertAdjacentHTML('beforeend', `<iframe ${iframeAttributes}>`);
    element.lastElementChild.src = element.dataset.iframeSrc;
  }

  if (element.dataset.scriptSrc) {
    const script = document.createElement('script');
    script.src = element.dataset.scriptSrc;
    element.insertAdjacentElement('beforeend', script);
  }
}

function initPrivacyPrompt(element, addRejectButton) {
  const platform = element.dataset.platform;
  const group = element.closest('.js-privacy-group');

  const showPrivacyPrompt = () => {
    element.insertAdjacentHTML(
      'beforeend',
      `<div class="c-privacy-prompt">
        <p class="js-privacy-please-confirm c-paragraph"></p>
        <p class="js-privacy-terms-platform c-paragraph"><a target="_blank" rel="noreferrer"></a></p>
        <div class="js-privacy-remember c-privacy-prompt__remember c-form-group">
          <label class="c-label c-label--beside">
            <input class="c-checkbox" type="checkbox" value="1" />
            <span class="c-label__inner c-label__inner--beside"></span>
          </label>
        </div>
        <div class="c-privacy-prompt__button-group">
          <button class="js-privacy-accept c-privacy-prompt__button c-privacy-prompt__button--accept c-button c-button--style-default c-button--size-regular"></button>
        </div>
      </div>`
    );

    const platformLink = element.querySelector('.js-privacy-terms-platform a');
    const checkbox = element.querySelector('.js-privacy-remember input');
    const acceptButton = element.querySelector('.js-privacy-accept');

    acceptButton.addEventListener('click', () => {
      if (checkbox.checked) {
        Cookies.set(
          'terms-accepted-' + platform,
          '1',
          { expires: 365, secure: true }
        );

        document.querySelectorAll('[data-platform="' + platform + '"]').forEach(element2 => {
          showContent(element2);
        });
      } else if (group) {
        group.querySelectorAll('[data-platform="' + platform + '"]').forEach(element2 => {
          showContent(element2);
        });
      } else {
        showContent(element);
      }
    });

    if (addRejectButton) {
      element.lastElementChild.lastElementChild.insertAdjacentHTML(
        'beforeend',
        `<button class="js-privacy-reject c-privacy-prompt__button c-privacy-prompt__button--reject c-button c-button--style-default c-button--size-regular" data-fancybox-close></button>`
      );
      element.querySelector('.js-privacy-reject').textContent = localize('privacy.reject.' + platform);
    }

    platformLink.href = localize('privacy.terms_link.' + platform);
    platformLink.textContent = localize('privacy.terms_link_text.' + platform);

    element.querySelector('.js-privacy-remember span').textContent = localize('privacy.remember.' + platform);

    let implicationsText = localize('privacy.implications_text').replace(
      '%s',
      localize('privacy.name.' + platform)
    );

    if (group) {
      element.querySelector('.js-privacy-please-confirm').textContent = localize('privacy.confirm.plural.' + platform) + ' ' + implicationsText;
      acceptButton.textContent = localize('privacy.accept.plural.' + platform);
    } else {
      element.querySelector('.js-privacy-please-confirm').textContent = localize('privacy.confirm.' + platform) + ' ' + implicationsText;
      acceptButton.textContent = localize('privacy.accept.' + platform);
    }
  };

  if (Cookies.get('terms-accepted-' + platform) === '1') {
    showContent(element);
  } else {
    showPrivacyPrompt();
  }
}

function initLightboxLink(link, platform, width, height) {
  link.addEventListener('click', event => {
    event.preventDefault();

    const privacyPopup = document.createElement('div');
    privacyPopup.dataset.platform = platform;
    privacyPopup.dataset.iframeSrc = link.href;
    privacyPopup.dataset.iframeAttributes = 'class="o-embed__content o-ratio__content"';
    privacyPopup.dataset.hasPrivacyPrompt = '1';

    initPrivacyPrompt(privacyPopup, true);

    $.fancybox.open(
      $(privacyPopup),
      {
        margin: [0, 0],
        buttons: ['close'],
        lang: document.documentElement.lang.split('-')[0],
        smallBtn: false,
        spinnerTpl: '',
        width: width,
        height: height
      }
    );
  });
}

document.querySelectorAll('.js-privacy-prompt').forEach(element => {
  initPrivacyPrompt(element, false);
});

document.querySelectorAll('.js-podcast-teaser').forEach(link => {
  initLightboxLink(link, 'podcaster', '500', '325');
});

document.querySelectorAll('.js-video-link[href^="https://www.youtube-nocookie.com/"]').forEach(link => {
  initLightboxLink(link, 'youtube', '1280', '720');
});

document.querySelectorAll('.js-video-link[href^="https://player.vimeo.com/"]').forEach(link => {
  initLightboxLink(link, 'vimeo', '1280', '720');
});
